module.exports = __webpack_public_path__ + "static/media/ExMarkstheSpot_jacket.376f3243.jpg";